type Props = {
	onClick: () => void;
};
export default function DrawerButton({ onClick }: Props) {
	return (
		<button className="btn btn-outline-secondary" onClick={onClick}>
			<i className="fas fa-bars"></i>
		</button>
	);
}
